import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Picture from '../image/CloudFrontPicture';

const GalleryOverlay = ({ children, overlay, path }) => {
    const PatternContainer = styled.div`
        position: relative;
        top: 0;
        left: 0;
        max-width: ${overlay.width - 2}px;
        overflow: hidden;
        margin-left: auto;
        margin-right: auto;
    `;
    const PatternOverlay = styled.div`
        position: relative;
        top: 0;
        left: 0;
        z-index: 2;
        line-height: 0;
    `;

    return (
        <PatternContainer>
            {children}
            <PatternOverlay>
                <Picture
                    src={overlay.src} wepb={overlay.webp} png schnoffle
                    path={path}
                    altText='Sewing pattern shadow overlay, displays patterns as a figurine.'
                />
            </PatternOverlay>
        </PatternContainer>
    );
};

GalleryOverlay.propTypes = {
    overlay: PropTypes.shape({
        src: PropTypes.string.isRequired,
        webp: PropTypes.string.isRequired,
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        width2: PropTypes.number,
        height2: PropTypes.number,
    }).isRequired,
    path: PropTypes.string.isRequired,
};

export default GalleryOverlay;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/GalleryOverlay.js